import { useQuery, useMutation } from "@apollo/client";
import {
  GET_ALL_CLIENTS,
  INSERT_PROJECT_CLIENT,
  DELETE_PROJECT_CLIENT,
} from "../../graphql/homepage/client";

export const useDisplayClients = () => {
  return useQuery(GET_ALL_CLIENTS);
};

export const useInsertProjectClient = () => {
  return useMutation(INSERT_PROJECT_CLIENT, {
    update(
      cache,
      { data: { insert_home_page_project_client_one: newClient } }
    ) {
      const existingClients = cache.readQuery({ query: GET_ALL_CLIENTS });
      if (existingClients && newClient) {
        cache.writeQuery({
          query: GET_ALL_CLIENTS,
          data: {
            home_page_project_client: [
              ...existingClients.home_page_project_client,
              newClient,
            ],
          },
        });
      }
    },
    // onCompleted: (data) => {
    //   console.log("Client inserted:", data.insert_home_page_project_client_one);
    // },
  });
};

export const useDeleteProjectClient = () => {
  return useMutation(DELETE_PROJECT_CLIENT, {
    update(cache, { data: { delete_home_page_project_client: result } }) {
      const existingClients = cache.readQuery({ query: GET_ALL_CLIENTS });
      if (existingClients && result?.returning?.length > 0) {
        const deletedClient = result.returning[0];
        const updatedClients = existingClients.home_page_project_client.filter(
          (client) => client.name !== deletedClient.name
        );

        cache.writeQuery({
          query: GET_ALL_CLIENTS,
          data: {
            home_page_project_client: updatedClients,
          },
        });
      }
    },
    // onCompleted: (data) => {
    //   console.log("Client deleted:", data.delete_home_page_project_client);
    // },
  });
};
